<template>
  <div class="container__parameter">
    <div class="table__container">
      <table class="parameters__table">
        <!--   Name Description 글씨 써있는 부분    -->
        <thead>
        <tr>
          <th class="col__header param__name">Name</th>
          <th class="col__header param__description">Description</th>
        </tr>
        </thead>

        <!-- 파라미터가 들어있는 만큼 뿌려주려고 파람 for문 돌리면서 뿌려줌     -->
        <tbody v-for="param in params">
        <!-- access_token, name 등등 써있는 거 -->
        <tr :param-name="param.name" :param-in="param.in">
          <td class="param__name">
            <div class="param__name__required">
              {{ param.name }}
              <span class="after" v-if="param.required === true">
                  *required</span
              >
            </div>

            <!-- 이름 아래 써져 있는 string, number 등의 작은 글씨 -->
            <div v-if="commonLanguage == null">
              <div class="param__type">
                {{ param.schema.type }}
              </div>
            </div>
            <!-- 토큰 혼자 schema에 없고 $ref를 통해서 있길래,,, 따로해 줌-->
            <div v-else>
              <div class="param__type">
                {{ commonLanguage.type }}
              </div>
            </div>

            <!-- (header) 이런 거임 -->
            <div class="param__in">({{ param.in }})</div>
          </td>

          <!-- 파라미터 description부분 -->
          <td class="param__description">
            <div class="param__des">
              <p>{{ param.description }}</p>
            </div>

            <!-- description아래 부분들 (schema지옥^^) -->
            <div class="param__schema">
              <!-- 1. schema에 $ref가 들어있는 경우(token) -->
              <div v-if="param.schema.$ref != null">
                <div class="param__enum">
                  <p>
                    <i>Available values</i>
                    : {{ commonLanguage.enum.toString() }}
                  </p>
                </div>
                <div class="param__default">
                  <p>
                    <i>Default values</i>
                    : {{ commonLanguage.default }}
                  </p>
                </div>
                <select>
                  <option>---</option>
                  <option
                      v-for="commonEnum in commonLanguage.enum"
                      :value="commonEnum"
                      :selected="commonEnum === 'jpn'"
                  >
                    {{ commonEnum }}
                  </option>
                </select>
              </div>

              <!-- 2. schema에 $ref말고 다른 것들이 들어가 있는 경우 -->
              <div v-else>
                <!-- 3. schema에 available 뿌려주기(enum이랑 같은듯) -->
                <div v-if="param.schema.enum" class="param__avail">
                  <p>
                    <i>Available values</i>
                    : {{ param.schema.enum.toString() }}
                  </p>
                </div>

                <!-- 4. schema에 default 값들이 있는 경우 -->
                <div
                    v-if="
                      typeof param.schema.default == 'string' ||
                      typeof param.schema.default == 'number'
                    "
                    class="param__default"
                >
                  <p>
                    <i>Default values</i>
                    : {{ param.schema.default }}
                  </p>
                </div>

                <!-- 5. schema에 enum이 있는 경우 -->
                <div v-if="param.schema.enum">
                  <select class="param__enumList">
                    <option>---</option>
                    <option
                        v-for="schemaEnum in param.schema.enum"
                        :value="schemaEnum"
                    >
                      {{ schemaEnum }}
                    </option>
                  </select>
                </div>

                <!-- 6. schema에 type이 있는데, 타입이 string인 지, number인 지 구분함 -->
                <label v-if="param.schema.type !== null">
                  <input
                      v-if="param.schema.type === 'string'"
                      type="text"
                      :placeholder="`${param.name} - ${param.description}`"
                      disabled="disabled"
                  />
                  <input
                      v-if="param.schema.type === 'number'"
                      type="text"
                      :placeholder="`${param.schema.default}`"
                      disabled="disabled"
                  />
                </label>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// Files
import commonFile from '../data/document/schemas/common.yaml';

export default {
  name: 'ParameterComponent',
  props: {
    params: Array,
  },
  computed: {
    commonLanguage() {
      let schemaUrl;
      this.params.forEach((item) => {
        if ('$ref' in item.schema) {
          schemaUrl = item.schema['$ref'];
        }
      });
      if (!schemaUrl) return;
      const schemaVal = schemaUrl.split('#/')[1];
      if (!schemaVal) return;

      return commonFile[schemaVal];
    },
  },
};
</script>

<style scoped lang="scss">
div {
  display: block;
}

table thead tr th {
  font-size: 12px;
  font-weight: 700;
  padding: 12px 0;
  text-align: left;
  border-bottom: 1px solid rgba(59, 65, 81, 0.2);
  font-family: sans-serif;
  color: #3b4151;
}

tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

td {
  min-width: 15em;
  padding: 10px 0;
}

p {
  font-size: 16px;
  margin: 1em auto;
  word-break: break-word;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0;
  margin-inline-end: 0;
}

input {
  width: 100%;
  max-width: 340px;
  background-color: #fafafa;
  color: #888;
  cursor: not-allowed;
  min-width: 100px;
  margin: 5px 0;
  padding: 8px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-family: 'Meiryo', sans-serif;
}

select {
  min-width: 230px;
  font-size: 14px;
  font-weight: 700;
  padding: 5px 40px 5px 10px;
  border: 2px solid #41444e;
  border-radius: 4px;
  background: #f7f7f7;
  background-size: 20px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 25%);
  font-family: sans-serif;
}

.after {
  font-size: 10px;
  position: relative;
  top: -6px;
  padding: 5px;
  content: 'required';
  color: rgba(255, 0, 0, 0.6);
}

.col__header {
  font-weight: 700;
  font-size: 12px;
  color: #3b4151;
  font-family: sans-serif;
  padding: 12px 0;
}

.param__name {
  font-weight: 700;
  margin-right: 0.75em;
  font-family: sans-serif;
  color: #3b4151;

  .param__name__required {
    font-size: 16px;
    font-weight: 700;
  }

  .param__type {
    font-size: 12px;
    padding: 5px 0;
    font-family: monospace;
    font-weight: 600;
    color: #3b4151;
  }

  .param__in {
    font-size: 12px;
    font-style: italic;
    font-family: monospace;
    font-weight: 600;
    color: grey;
  }
}

.param__description {
  width: 99%;
  margin-bottom: 2em;

  .param__enum {
  }

  .param_default {
  }
}
</style>
